import { useTranslation } from "react-i18next";
import { Calculator } from "lucide-react";

// بطاقة "المشتقّات التلقائية" — تعرض القيم المحسوبة من سعر التوكن (للاطلاع فقط).
const TOKENS_PER_EMP = 52; // 2 × 26

export const DerivedPricingCard = ({ config }) => {
  const { t } = useTranslation();
  const currency = config.currency || "USD";
  const price = Number(config.price_per_token) || 0;
  const perEmployee = (price * TOKENS_PER_EMP).toFixed(4);
  const per10 = (price * TOKENS_PER_EMP * 10).toFixed(2);
  const per100 = (price * TOKENS_PER_EMP * 100).toFixed(2);
  const welcomeSuggestion = Math.round(TOKENS_PER_EMP * 7 / 26);

  const rows = [
    { label: t("tokens.derivedPerEmployee"), value: `${perEmployee} ${currency}` },
    { label: t("tokens.derivedMinPerEmployee"), value: `${TOKENS_PER_EMP} ${t("tokens.unitToken")}` },
    { label: t("tokens.derivedFor10"), value: `${per10} ${currency}` },
    { label: t("tokens.derivedFor100"), value: `${per100} ${currency}` },
    { label: t("tokens.derivedWelcomePerEmp"), value: `${welcomeSuggestion} ${t("tokens.unitToken")}` },
  ];

  return (
    <div className="mt-4 rounded-2xl bg-background p-4 shadow-neu-in" data-testid="derived-pricing-card">
      <div className="flex items-center gap-2">
        <Calculator className="h-4 w-4 text-primary" />
        <p className="text-sm font-black">{t("tokens.derivedTitle")}</p>
      </div>
      <p className="mt-1 text-[11px] text-muted-foreground">{t("tokens.derivedHint")}</p>
      <ul className="mt-3 grid gap-2 sm:grid-cols-2">
        {rows.map((r) => (
          <li key={r.label} className="flex items-center justify-between rounded-xl bg-background px-3 py-2 shadow-neu-sm">
            <span className="text-[11px] font-bold text-muted-foreground">{r.label}</span>
            <span className="font-mono text-sm font-black text-primary">{r.value}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
